import ConfirmationComponent from "./ConfirmationComponent";

const ConfirmPlugin = {
  install(Vue) {
    Vue.component("ConfirmationComponent", ConfirmationComponent);

    Vue.prototype.$confirm = {
      show(params) {
        Event.$emit("show", params);
      },
    };
  },
};

export default ConfirmPlugin;
